import { render } from "./TrackAndWithdrawIncomeBanner.vue?vue&type=template&id=05f8a412&scoped=true"
import script from "./TrackAndWithdrawIncomeBanner.vue?vue&type=script&lang=js"
export * from "./TrackAndWithdrawIncomeBanner.vue?vue&type=script&lang=js"

import "./TrackAndWithdrawIncomeBanner.vue?vue&type=style&index=0&id=05f8a412&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f8a412"]])

export default __exports__